import React from 'react';

import Button from "./Button"
import Card from "./Card"
import Set from "./Set"

function Exercise({ exercise, sets, addSet, updateSet }) {
    return (
        <Card>
            <Button className="ph3 fr bg-navy" onClick={addSet} text="Add Set" />
            <h1 className="f4 mt0">{exercise.name}</h1>
            {exercise.sets.map(setId =>
                <Set
                    key={setId}
                    type={exercise.type}
                    set={sets[setId]}
                    updateSet={(key, value) => updateSet(setId, key, value)} />)}
        </Card>
    )
}

export default Exercise